<template>
  <div class="boxbgcolor">
    <div class="right content-right list">
      <!-- 搜索区域 -->
      <div class="searchbox">
        <form action="#" method="get" class="form-inline form-float">
          <div class="form-group">
            <label>发票号:</label>
            <el-input
              v-model="searchForm.invoiceNo"
              placeholder="请输入发票号"
              clearable
              class="form-control"
            />
          </div>
          <div class="form-group">
            <label>客户名称:</label>
            <el-input
              v-model="searchForm.customerName"
              placeholder="请输入客户名称"
              clearable
              class="form-control"
            />
          </div>
          <!-- <div class="form-group">
            <label>车牌号:</label>
            <el-input
              v-model="searchForm.plateNumber"
              placeholder="请输入车牌号"
              clearable
              class="form-control"
            />
          </div> -->
          <div class="form-group">
            <label>开票日期:</label>
            <el-date-picker
              clearable
              value-format="yyyy-MM-dd HH:mm:ss"
              v-model="searchForm.dateRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              format="yyyy-MM-dd"
            >
            </el-date-picker>
          </div>
          <div class="form-group others">
            <span class="search_btn">
              <el-button
                @click="handleSearch"
                type="button"
                class="btn btn-primary"
                id="search_btn"
              >
                查询
              </el-button>
            </span>
            <span class="search_btn">
              <el-button
                @click="handleReset"
                type="button"
                class="btn btn-default"
              >
                重置
              </el-button>
            </span>
          </div>
        </form>
      </div>

      <!-- 表格区域 -->
      <div class="list-right">
        <el-table
          :data="tableData"
          border
          stripe
          v-loading="loading"
          style="width: 100%"
          height="100%"
          :header-cell-style="tableHeaderStyle"
          :cell-style="tableCellStyle"
          highlight-current-row
        >
          <el-table-column
            prop="invoiceNo"
            label="发票号"
            width="180"
            show-overflow-tooltip
          />
          <el-table-column
            prop="titleType"
            label="抬头类型"
            width="120"
            align="center"
          >
            <template #default="scope">
              <el-tag
                :type="scope.row.titleType === '个人' ? 'success' : 'primary'"
              >
                {{ scope.row.titleType }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column
            prop="customerName"
            label="客户名称"
            width="200"
            show-overflow-tooltip
          />
          <el-table-column
            prop="invoiceDate"
            label="开票日期"
            width="120"
            align="center"
          />
          <el-table-column prop="amount" label="金额" width="120" align="right">
            <template #default="scope">
              <span>¥{{ scope.row.amount.toFixed(2) }}</span>
            </template>
          </el-table-column>

          <el-table-column
            prop="orderType"
            label="订单类型"
            width="120"
            align="center"
          >
            <template #default="scope">
              <el-tag :type="getOrderTypeTagType(scope.row.orderType)">
                {{ scope.row.orderType }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column
            prop="invoiceStatus"
            label="开票状态"
            width="120"
            align="center"
          />
          <el-table-column
            label="操作"
            width="120"
            align="center"
            fixed="right"
          >
            <template #default="scope">
              <el-button
                type="primary"
                size="small"
                @click="handleViewOrder(scope.row)"
              >
                关联订单
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <Page v-on:pagination="receivePaginationData"></Page>
  </div>
</template>

<script>
import Page from "@/page/commons/page";
export default {
  name: "InvoiceRecord",
  data() {
    return {
      // 搜索表单
      searchForm: {
        invoiceNo: "",
        customerName: "",
        plateNumber: "",
        dateRange: [],
      },
      // 表格数据
      tableData: [],
      // 加载状态
      loading: false,
      // 分页信息
      pagination: {
        currentPage: 1,
        pageSize: 20,
        total: 0,
      },
    };
  },
  components: { Page },
  computed: {
    // 表格头部样式
    tableHeaderStyle() {
      return {
        backgroundColor: "#f8f9fa",
        color: "#2c3e50",
        fontWeight: "600",
        fontSize: "14px",
        textAlign: "center",
        border: "none",
      };
    },
    // 表格单元格样式
    tableCellStyle() {
      return {
        fontSize: "13px",
        padding: "12px 0",
        textAlign: "center",
      };
    },
  },
  mounted() {
    this.fetchInvoiceRecords();
  },
  methods: {
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;
      this.fetchInvoiceRecords();
    },
    // 获取发票记录列表
    async fetchInvoiceRecords() {
      this.loading = true;
      try {
        // 模拟API调用
        await new Promise((resolve) => setTimeout(resolve, 1000));

        // 模拟数据
        this.tableData = [
          {
            id: 1,
            invoiceNo: "FP20241201001",
            titleType: "个人",
            customerName: "张三",
            invoiceDate: "2024-12-01",
            amount: 25.0,
            plateNumber: "京A12345",
            orderType: "路边停车",
            orderId: "ORD001",
            invoiceStatus: "已开票",
          },
          {
            id: 2,
            invoiceNo: "FP20241201002",
            titleType: "企业",
            customerName: "北京科技有限公司",
            invoiceDate: "2024-12-01",
            amount: 150.0,
            plateNumber: "京B67890",
            orderType: "停车场",
            orderId: "ORD002",
            invoiceStatus: "开票中",
          },
          {
            id: 3,
            invoiceNo: "FP20241201003",
            titleType: "个人",
            customerName: "李四",
            invoiceDate: "2024-12-01",
            amount: 80.0,
            plateNumber: "京C11111",
            orderType: "月卡",
            orderId: "ORD003",
            invoiceStatus: "已开票",
          },
        ];

        this.pagination.total = this.tableData.length;
      } catch (error) {
        console.error("获取发票记录失败:", error);
        this.$message.error("获取发票记录失败");
      } finally {
        this.loading = false;
      }
    },

    // 搜索
    handleSearch() {
      this.pagination.currentPage = 1;
      this.fetchInvoiceRecords();
    },

    // 重置搜索
    handleReset() {
      this.searchForm = {
        invoiceNo: "",
        customerName: "",
        plateNumber: "",
        dateRange: [],
      };
      this.handleSearch();
    },

    // 导出
    handleExport() {
      this.$message.success("导出功能开发中");
    },

    // 刷新
    handleRefresh() {
      this.fetchInvoiceRecords();
    },

    // 查看关联订单 - 跳转到订单详情页面
    handleViewOrder(row) {
      // 跳转到订单详情页面，传递订单ID
      this.$router.push({
        path: "/main/invoice/order-detail",
        query: {
          orderId: row.orderId,
          invoiceNo: row.invoiceNo,
          plateNumber: row.plateNumber,
        },
      });
    },

    // 分页大小改变
    handleSizeChange(size) {
      this.pagination.pageSize = size;
      this.pagination.currentPage = 1;
      this.fetchInvoiceRecords();
    },

    // 当前页改变
    handleCurrentChange(page) {
      this.pagination.currentPage = page;
      this.fetchInvoiceRecords();
    },

    // 获取订单类型标签样式
    getOrderTypeTagType(orderType) {
      const typeMap = {
        路边停车: "warning",
        停车场: "primary",
        月卡: "success",
      };
      return typeMap[orderType] || "info";
    },
  },
};
</script>

<style scoped>
/* 页面布局样式 - 项目标准版本 */
.boxbgcolor {
  background: #fff;
  display: flex;
  justify-content: flex-start;
  height: 100%;
}

.content-right {
  width: 100%;
}

.list {
  padding: 0 16px 40px;
  height: calc(100vh - 125px);
}

/* 搜索区域样式 - 项目标准版本 */
.searchbox {
  background: #f9f9fb;
  border-bottom: 10px solid #eff2f7;
  padding: 10px;
  margin-bottom: 0;
}

.form-inline {
  display: flex;
  display: -webkit-flex;
  flex-wrap: wrap;
  align-items: center;
  height: 80px;
  vertical-align: middle;
}

.form-group {
  margin-bottom: 2px;
  margin-right: 10px;
}

.form-group label {
  margin-right: 10px;
  font-weight: 100;
  color: #222;
}

.form-control {
  border-radius: 4px;
  /* border: 1px solid #dcdfe6; */
  transition: border-color 0.2s ease;
  border: none !important;
  box-shadow: none !important;
}

/* 修复form-group的垂直对齐 */
.form-group {
  margin-bottom: 2px;
  margin-right: 10px;
  display: flex !important;
  align-items: center !important;
  vertical-align: middle !important;
}

.form-group label {
  margin-right: 10px;
  font-weight: 100;
  color: #222;
  line-height: 1 !important;
  margin-bottom: 0 !important;
  display: flex !important;
  align-items: center !important;
}

.form-control:focus {
  border-color: #409eff;
}

.others {
  display: -webkit-flex !important;
  display: flex !important;
  justify-content: center;
}

.search_btn {
  display: inline-block;
  margin-right: 5px;
}

/* 按钮样式 - 项目标准版本 */
.btn {
  border-radius: 0px;
  border: 1px solid #409eff;
  color: #409eff;
  padding: 6px 20px;
  transition: all 0.2s ease;
}

.btn-primary {
  color: #fff;
  background-color: #409eff;
  border-color: #409eff;
}

.btn-primary:hover,
.btn-primary:focus,
.btn-primary:active {
  background-color: #66b1ff !important;
  border-color: #66b1ff !important;
}

.btn-primary:active {
  background-color: #3a8ee6 !important;
  border-color: #3a8ee6 !important;
}

.btn-default {
  background: none;
  color: #409eff;
}

.btn-default:hover {
  background-color: #409eff;
  color: #fff;
}

/* 表格区域样式 - 项目标准版本 */
.list-right {
  background: #ffffff;
  border-radius: 8px;

  overflow: hidden;
  height: calc(100vh - 250px);
  /* overflow: auto; */
  padding-bottom: 20px;
}

/* 表格美化样式 - 与项目统一 */
.el-table {
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: 1px solid #e4e7ed;
}

/* 表头样式优化 - 简化版本 */
.el-table th {
  background: #f8f9fa !important;
  color: #2c3e50 !important;
  font-weight: 600 !important;
  border: none !important;
  border-bottom: 1px solid #e4e7ed !important;
  transition: background-color 0.2s ease;
}

.el-table th:hover {
  background: #e9ecef !important;
}

/* 表格行悬停效果 - 简化版本 */
.el-table tbody tr {
  transition: background-color 0.2s ease;
  border-bottom: 1px solid #f0f0f0;
}

.el-table tbody tr:hover > td {
  background: #f8f9fa !important;
}

/* 斑马纹效果 */
.el-table--striped .el-table__body tr.el-table__row--striped td {
  background-color: #fafbfc;
}

/* 表格边框优化 */
.el-table--border th,
.el-table--border td {
  border-right: 1px solid #ebeef5;
}

/* 当前行高亮 */
.el-table__current-row > td {
  background-color: #e3f2fd !important;
}

/* 金额列特殊样式 - 简化版本 */
.amount-text {
  font-family: "DS-DIGI", monospace;
  font-size: 16px;
  font-weight: 600;
  color: #2e7d32;
  background: #f1f8e9;
  padding: 4px 8px;
  border-radius: 4px;
  border-left: 2px solid #4caf50;
  display: inline-block;
  min-width: 80px;
  text-align: center;
}

/* 标签样式优化 - 简化版本 */
.el-tag {
  border-radius: 4px;
  font-weight: 500;
  padding: 2px 8px;
  transition: all 0.2s ease;
}

.el-tag:hover {
  transform: none;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

/* 操作按钮样式 - 简化版本 */
.el-button--primary {
  border-radius: 4px;
  font-weight: 500;
  transition: all 0.2s ease;
}

.el-button--primary:hover {
  transform: none;
  box-shadow: 0 2px 4px rgba(64, 158, 255, 0.2);
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .form-group {
    margin-right: 8px;
  }
}

@media (max-width: 992px) {
  .form-group {
    margin-right: 6px;
  }
}

@media (max-width: 768px) {
  .searchbox {
    padding: 8px;
  }

  .form-inline {
    height: auto;
    flex-direction: column;
    align-items: stretch;
  }

  .form-group {
    margin-right: 0;
    margin-bottom: 10px;
  }

  .list-right {
    margin: 10px;
  }
}

@media (max-width: 480px) {
  .searchbox {
    padding: 6px;
  }

  .form-group {
    margin-bottom: 8px;
  }
}
</style>
